module.exports = __webpack_public_path__ + "assets/2da93109e8bc1a81e0e51b588431a106.png";